import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import imgGestaoPets from '../assets/feature-gestao-pets.jpg';
import imgAgendamento from '../assets/feature-agendamento.jpg';
import imgTransmissao from '../assets/feature-transmissao.png';
import imgDashboard from '../assets/feature-dashboard.jpg';
import imgArmazenamento from '../assets/feature-armazenamento.png';
import imgNotificacoes from '../assets/feature-notificacoes.jpg';
import imgFocoPets from '../assets/highlight-foco-pets.jpg';
import imgDadosTempoReal from '../assets/highlight-dados-tempo-real.jpg';
import imgMultiUnidades from '../assets/highlight-multi-unidades.jpg';
import foto from '../assets/foto.png';
import logo from '../assets/home-branco.png';
import {
  AppBar,
  Toolbar,
  Box,
  Container,
  Typography,
  Button,
  Tabs,
  Tab,
  Grid,
  Card,
  CardContent,
  CardMedia,
  CardActions,
  Chip,
  Divider,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
} from '@mui/material';
import {
  Pets,
  CheckCircle,
  Event,
  BarChart,
  Business,
  Star,
  HealthAndSafety,
  NotificationsActive,
  Login,
  ArrowBack,
  Menu,
} from '@mui/icons-material';
import { useMediaQuery, useTheme } from '@mui/system';

const FEATURES = [
  {
    title: 'Gerenciamento de donos e pets',
    description:
      'Organização completa das informações dos seus clientes e seus animais.',
    detailedDescription:
      'A plataforma permite cadastrar e gerenciar de forma simples todos os donos e seus pets, mantendo um histórico organizado e de fácil acesso. Para os donos dos pets, você pode armazenar informações como nome, telefone, documento e email, facilitando o contato e a identificação. Já para os pets, é possível manter os dados vinculados ao seu responsável, garantindo uma visão clara de cada atendimento realizado.',
    image: imgGestaoPets,
    icon: <Pets fontSize="large" />,
  },
  {
    title: 'Gestão de serviços',
    description:
      'Organize e padronize todos os serviços oferecidos pelo seu petshop.',
    detailedDescription:
      'A plataforma permite cadastrar diferentes tipos de serviços, como banho, tosa e outros atendimentos, definindo informações como valor e duração do serviço. Isso facilita a padronização dos processos e garante mais controle sobre o que é oferecido aos clientes. Além disso, você consegue identificar facilmente quais serviços são mais realizados, ajudando na tomada de decisões e na criação de estratégias para aumentar o faturamento.',
    image: imgAgendamento,
    icon: <Event fontSize="large" />,
  },
  {
    title: 'Transmissão ao vivo',
    description:
      'Ofereça total transparência para seus clientes.',
    detailedDescription:
      'Ao iniciar um atendimento, a plataforma gera um link exclusivo de transmissão ao vivo, permitindo que o dono acompanhe o serviço em tempo real. Isso aumenta a confiança no seu trabalho e melhora significativamente a experiência do cliente.',
    image: imgTransmissao,
    icon: <HealthAndSafety fontSize="large" />,
  },
  {
    title: 'Relatórios e Dashboard',
    description:
      'Tenha uma visão completa do seu petshop em tempo real.',
    detailedDescription:
      'A dashboard reúne as principais métricas do seu negócio em um único lugar, permitindo acompanhar o desempenho de forma simples e visual. Você pode analisar o faturamento mensal, identificando períodos de maior lucro, além de visualizar os serviços mais realizados, ajudando a entender o que mais gera demanda no seu estabelecimento. Também é possível acompanhar os pets mais atendidos, facilitando a identificação de clientes recorrentes, e a duração dos atendimentos, permitindo otimizar o tempo da equipe e melhorar a produtividade.',
    image: imgDashboard,
    icon: <BarChart fontSize="large" />,
  },
  {
    title: 'Armazenamento das transmissões',
    description:
      'Segurança para você e para o cliente.',
    detailedDescription:
      'Todas as transmissões ficam salvas automaticamente, criando um histórico completo de cada atendimento. Caso aconteça qualquer situação com o pet, o dono pode acessar o vídeo posteriormente e verificar exatamente o que ocorreu. Esse recurso protege seu negócio e traz ainda mais transparência ao serviço prestado.',
    image: imgArmazenamento,
    icon: <Business fontSize="large" />,
  },
  {
    title: 'Integração com WhatsApp',
    description:
      'Comunicação rápida e sem esforço.',
    detailedDescription:
      'Assim que o atendimento começa, o sistema envia automaticamente o link da transmissão para o cliente via WhatsApp. Isso elimina a necessidade de envio manual, agiliza o atendimento e garante que o cliente esteja sempre informado.',
    image: imgNotificacoes,
    icon: <NotificationsActive fontSize="large" />,
  },
];

const PLANS = [
  {
    name: 'Básico',
    highlight: false,
    price: 'Grátis',
    period: '',
    description: 'Ideal para começar',
    features: [
      'Até 1 unidade',
      'Até 50 agendamentos/mês',
      'Cadastro de pets ilimitado',
      'Suporte por e-mail',
    ],
  },
  {
    name: 'Profissional',
    highlight: true,
    price: 'R$ 149',
    period: '/mês',
    description: 'Para petshops em crescimento',
    features: [
      'Até 3 unidades',
      'Agendamentos ilimitados',
      'Dashboard completo',
      'Relatórios avançados',
      'Suporte prioritário',
    ],
  },
  {
    name: 'Premium',
    highlight: false,
    price: 'R$ 299',
    period: '/mês',
    description: 'Para grandes redes',
    features: [
      'Unidades ilimitadas',
      'Tudo do Profissional',
      'Integrações avançadas',
      'Gerente de conta dedicado',
      'SLA garantido',
    ],
  },
];

const HIGHLIGHTS = [
  {
    icon: <Pets className="icon-lg" />,
    title: 'Foco nos pets',
    description: 'Plataforma 100% desenvolvida para o universo pet.',
    image: imgFocoPets,
  },
  {
    icon: <BarChart className="icon-lg" />,
    title: 'Controle de status dos atendimentos',
    description: 'Organize atendimentos por status como fila, em andamento e finalizado, garantindo mais controle e agilidade.',
    image: imgDadosTempoReal,
  },
  {
    icon: <Business className="icon-lg" />,
    title: 'Histórico completo de atendimentos',
    description: 'Acesse o histórico de todos os atendimentos realizados.',
    image: imgMultiUnidades,
  },
];

function TabPanel({ children, value, index }) {
  return (
    <Box
      role="tabpanel"
      hidden={value !== index}
      id={`landing-tabpanel-${index}`}
      aria-labelledby={`landing-tab-${index}`}
    >
      {value === index && <Box>{children}</Box>}
    </Box>
  );
}

export const LandingPage = () => {
  const navigate = useNavigate();
  const [isVisible, setIsVisible] = useState(false);
  const [activeTab, setActiveTab] = useState(0);
  const [selectedFeature, setSelectedFeature] = useState(null);
  const [drawerOpen, setDrawerOpen] = useState(false);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const handleTabChange = (_, newValue) => setActiveTab(newValue);

  const headerItems = [
    {
      label: 'Início',
      onClick: () => {
        setActiveTab(0);
        setDrawerOpen(false);
      },
    },
    {
      label: 'Funcionalidades',
      onClick: () => {
        setActiveTab(1);
        setDrawerOpen(false);
      },
    },
    {
      label: 'Planos',
      onClick: () => {
        setActiveTab(2);
        setDrawerOpen(false);
      },
    },
    {
      label: 'Entrar',
      onClick: () => {
        setDrawerOpen(false);
        navigate('/login');
      },
    },
  ];

  useEffect(() => {
    setTimeout(() => setIsVisible(true), 100);
  }, []);

  useEffect(() => {
  if (activeTab === 0 || activeTab === 1 || activeTab === 2) {
    const cards = document.querySelectorAll(".card-highlight, .card-feature, .card-plan");

    if (cards.length === 0) return;

    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2 }
    );

    cards.forEach(card => observer.observe(card));

    return () => observer.disconnect();
  }
}, [activeTab, selectedFeature]);

  return (
    <Box className="landing-root">
      <AppBar position="fixed" color="primary" elevation={2} sx={{ backgroundColor: '#331966' }}>
        <Toolbar className="toolbar-spaced">
          <Box className="logo-wrapper">
            <Button
              onClick={() => {
                setActiveTab(0);
                setDrawerOpen(false);
              }}
              sx={{ p: 0, minWidth: 'auto' }}
            >
              <img src={logo} alt="Petlive" className="logo-navbar" />
            </Button>
          </Box>

          {!isMobile && (
            <Box className="landing-tabs-nav">
              <Container maxWidth="lg">
                <Tabs
                  value={activeTab}
                  onChange={handleTabChange}
                  textColor="#fff"
                  indicatorColor="primary"
                  aria-label="navegação landing page"
                >
                  <Tab label="Início" id="landing-tab-0" className="text-transform-unset fw-semibold" />
                  <Tab label="Funcionalidades" id="landing-tab-1" className="text-transform-unset fw-semibold" />
                  <Tab label="Planos" id="landing-tab-2" className="text-transform-unset fw-semibold" />
                </Tabs>
              </Container>
            </Box>
          )}

          {!isMobile && (
            <Button
              variant="contained"
              startIcon={<Login />}
              onClick={() => navigate('/login')}
              className="text-transform-unset fw-bold btn-secondary"
            >
              Entrar
            </Button>
          )}
           {isMobile && (
              <IconButton
                size="large"
                edge="start"
                color="inherit"
                onClick={() => setDrawerOpen(true)}
                aria-label="abrir menu"
              >
                <Menu />
              </IconButton>
            )}
        </Toolbar>
      </AppBar>

      <Drawer
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        anchor="right"
        PaperProps={{
          sx: {
            width: 280,
            backgroundColor: '#331966',
            color: '#fff',
          },
        }}
      >
        <Box sx={{ p: 2, height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
          <Box>
            <List>
              {headerItems.map((item) => (
                <ListItem key={item.label} disablePadding>
                  <ListItemButton onClick={item.onClick} sx={{ color: '#fff' }}>
                    <ListItemText primary={item.label} primaryTypographyProps={{ fontWeight: 'bold' }} />
                  </ListItemButton>
                </ListItem>
              ))}
            </List>
          </Box>

          <Box sx={{ textAlign: 'center', mt: 4 }}>
            <img src={logo} alt="Petlive" style={{ width: '140px', objectFit: 'contain' }} />
          </Box>
        </Box>
      </Drawer>



      <Box>
        <TabPanel value={activeTab} index={0}>
          <Box className="landing-hero" height={isMobile ? "60vh" : "40vw"}>
            <Box width="100%" height="100%" display="flex" alignItems="center">
              <Container maxWidth="md">
                <Box width="100%" display='flex' flexDirection='column' alignItems='center' textAlign='center' marginTop={isMobile ? "10vw" : 0}>
                  <Typography
                    variant="h3"
                    component="h1"
                    className="fw-bold landing-hero-title"
                  >
                    Gerencie seu petshop<br></br> com inteligência
                  </Typography>
                  <Typography variant="h6" className="landing-hero-subtitle">
                    Gestão inteligente para petshops com controle,<br></br> transparência e confiança
                  </Typography>
                </Box>
                <Box className="landing-hero-actions">
                  <Button
                    variant="outlined"
                    onClick={() => setActiveTab(2)}
                    className="text-transform-unset fw-bold btn-ghost-white"
                  >
                    Ver planos
                  </Button>
                </Box>
              </Container>
            </Box>
          </Box>

          <Box
            display="flex"
            flexDirection={isMobile ? "column" : "row"}
            alignItems="center"
            justifyContent="space-between"
            padding={isMobile ? "30px 16px" : "50px"}
            margin={isMobile? 0: 15}
            marginTop={isMobile ? "30px" : "5vw"}
          >
            <Box
              maxWidth={isMobile ? "100%" : "700px"}
              maxHeight={isMobile ? "auto" : "40vw"}
            >
              <Typography
                variant={isMobile ? "subtitle2" : "subtitle1"}
                fontWeight="bold"
                color="#210144"
                letterSpacing="2px"
                textAlign="center"
              >
                PRINCIPAL DIFERENCIAL
              </Typography>

              <Typography
                variant={isMobile ? "h4" : "h3"}
                fontWeight="800"
                color="#331966"
                lineHeight="1.3"
                textAlign="center"
              >
                Transmissão de Serviços
              </Typography>

              <Typography
                variant={isMobile ? "h5" : "h4"}
                color="#380470ff"
                fontWeight="800"
                textAlign="center"
              >
                e Conforto do Cliente
              </Typography>

              <Typography
                variant={isMobile ? "body2" : "body1"}
                marginTop="20px"
                color="#333"
                lineHeight="1.6"
                textAlign="center"
              >
                O carinho não para quando o dono não está por perto.
                Nossa plataforma transmite o banho e outros serviços do seu pet em tempo real,
                proporcionando confiança, tranquilidade e uma experiência única para tutores e estabelecimentos.
              </Typography>
            </Box>


            <img
              src={foto}
              alt="logo"
              style={{
                width: isMobile ? "100%" : "100%",
                height: isMobile ? "auto" : "100%",
                maxWidth: isMobile ? "420px" : "50vw",
                maxHeight: isMobile ? "480px" : "50vw",
                objectFit: "cover",
                borderRadius: "12px",
                marginTop: isMobile ? "30px" : "0",
                transform: isVisible ? "translateY(0)" : "translateY(60px)",
                opacity: isVisible ? 1 : 0,
                transition: "all 1s ease-out",
              }}
            />
          </Box>

          <Box width="100%" backgroundColor="#331966" marginTop="10vw" marginBottom="10vw">
            <Container maxWidth="lg" className="section-py">
              <Typography
                variant="h4"
                align="center"
                color='#fff'
                className="fw-bold"
              >
                Por que escolher a Petlive?
              </Typography>
              <Typography
                variant="body1"
                align="center"
                color="#fff"
                className="section-subtitle-5"
              >
                Tudo que você precisa para crescer com eficiência e qualidade.
              </Typography>
              <Grid container spacing={4} justifyContent="center" flexDirection={{ xs: "column", md: "row" }}>
                {HIGHLIGHTS.map((item, index) => (
                  <Grid item xs={12} sm={6} md={6} key={item.title}>
                    <Card elevation={2} className="card-highlight" style={{ animationDelay: `${index * 0.2}s` }}>
                      <CardMedia
                        component="img"
                        height="160"
                        image={item.image}
                        alt={item.title}
                        className="img-cover"
                      />
                      <CardContent>
                        <Box className="icon-circle">{item.icon}</Box>
                        <Typography
                          variant="h6"
                          className="fw-bold highlight-card-title"
                        >
                          {item.title}
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                          {item.description}
                        </Typography>
                      </CardContent>
                    </Card>
                  </Grid>
                ))}
              </Grid>
            </Container>
          </Box>


        </TabPanel>

        <TabPanel value={activeTab} index={1}>
          <Container maxWidth="lg" className="section-py">
            {selectedFeature ? (
              <Box width="100%">
                <Button
                  variant="outlined"
                  onClick={() => setSelectedFeature(null)}
                  startIcon={<ArrowBack />}
                  className="mb-3"
                >
                  Voltar
                </Button>
                <Box width="100%" display="flex" flexDirection="row">
                  <Grid container spacing={4} alignItems="center">
                    <Box width="100%" display="flex" justifyContent="space-between" flexDirection={{ xs: "column", md: "row" }} marginTop="5vw" gap={4}>
                      <Box width={isMobile ? "100%" : "50%"} >
                        <Typography variant="h4" className="fw-bold mb-3" color='#331966'>
                          {selectedFeature.title}
                        </Typography>
                        <Typography variant="body1" color="text.secondary">
                          {selectedFeature.detailedDescription}
                        </Typography>
                      </Box>
                      <Box width={isMobile ? "100%" : "50%"}>
                        <img
                          src={selectedFeature.image}
                          alt={selectedFeature.title}
                          style={{
                            width: '100%',
                            height: 'auto',
                            maxHeight: '400px',
                            objectFit: 'cover',
                            borderRadius: '12px',
                          }}
                        />
                      </Box>
                    </Box>
                  </Grid>
                </Box>
              </Box>
            ) : (
              <>
                <Box width="100%">
                  <Typography
                    variant="h4"
                    align="center"
                    className="fw-bold section-title"
                  >
                    Funcionalidades
                  </Typography>
                  <Typography
                    variant="body1"
                    align="center"
                    color="text.secondary"
                    className="section-subtitle-6"
                  >
                    Uma solução completa do agendamento ao faturamento.
                  </Typography>

                  <Box width="100%" display="flex" justifyContent="center">
                    <Grid container spacing={6}>
                      {FEATURES.map((feature, index) => (
                        <Grid item xs={12} sm={6} md={4} key={feature.title}>
                          <Card
                            elevation={2}
                            className="card-feature"
                            onClick={() => setSelectedFeature(feature)}
                             style={{ animationDelay: `${index * 0.2}s` , cursor: 'pointer' }}
                          >
                            <CardMedia
                              component="img"
                              height="180"
                              image={feature.image}
                              alt={feature.title}
                              className="img-cover"
                            />
                            <CardContent className="card-content-grow">
                              <Box className="feature-header">
                                {feature.icon}
                                <Typography
                                  variant="h6"
                                  className="fw-bold feature-title"
                                >
                                  {feature.title}
                                </Typography>
                              </Box>
                              <Typography variant="body2" color="text.secondary">
                                {feature.description}
                              </Typography>
                            </CardContent>
                          </Card>
                        </Grid>
                      ))}
                    </Grid>
                  </Box>
                </Box>
              </>
            )}
          </Container>
        </TabPanel>

        <TabPanel value={activeTab} index={2}>
          <Container maxWidth="lg" className="section-py">
            <Typography
              variant="h4"
              align="center"
              className="fw-bold section-title"
            >
              Planos e Preços
            </Typography>
            <Typography
              variant="body1"
              align="center"
              color="text.secondary"
              className="section-subtitle-6"
            >
              Escolha o plano ideal para o porte do seu negócio.
            </Typography>

            <Grid container spacing={isMobile ? 10 : 4} alignItems="stretch" justifyContent="center" flexDirection={{ xs: "column", md: "row" }} marginTop="5vw">
              {PLANS.map((plan, index) => (
                <Grid item xs={12} sm={8} md={4} key={plan.name}>
                  <Card
                    elevation={plan.highlight ? 8 : 2}
                    className={`card-plan${plan.highlight ? ' card-plan-highlight' : ''}`}
                    style={{ animationDelay: `${index * 0.2}s` }}
                  >
                    {plan.highlight && (
                      <Chip
                        label="Mais popular"
                        icon={<Star className="icon-star-xs" />}
                        size="small"
                        className="fw-bold chip-popular"
                      />
                    )}

                    <CardContent
                      className={plan.highlight ? 'plan-content-highlight' : 'plan-content'}
                    >
                      <Typography
                        variant="h5"
                        className={`fw-bold plan-name${plan.highlight ? ' plan-name-highlight' : ''}`}
                      >
                        {plan.name}
                      </Typography>
                      <Typography
                        variant="body2"
                        color="text.secondary"
                        className="plan-desc"
                      >
                        {plan.description}
                      </Typography>

                      <Box className="price-row">
                        <Typography
                          variant="h4"
                          className={`fw-bold${plan.highlight ? ' price-highlight' : ''}`}
                        >
                          {plan.price}
                        </Typography>
                        {plan.period && (
                          <Typography
                            variant="body2"
                            color="text.secondary"
                            className="price-period"
                          >
                            {plan.period}
                          </Typography>
                        )}
                      </Box>

                      <Divider className="plan-divider" />

                      <Box className="features-list">
                        {plan.features.map((feat) => (
                          <Box key={feat} className="feature-item">
                            <CheckCircle
                              fontSize="small"
                              className={plan.highlight ? 'check-icon-highlight' : 'check-icon-default'}
                            />
                            <Typography variant="body2">{feat}</Typography>
                          </Box>
                        ))}
                      </Box>
                    </CardContent>

                    <CardActions className="card-actions-bottom">
                      <Button
                        fullWidth
                        variant={plan.highlight ? 'contained' : 'outlined'}
                        color="primary"
                        onClick={() => {
                          if (plan.price === 'Grátis') {
                            navigate('/login');
                          } else {
                            const msg = encodeURIComponent(
                              `Olá! Tenho interesse na plataforma Petlive no plano ${plan.name} (${plan.price}${plan.period}). Poderia me passar mais informações?`
                            );
                            window.open(`https://wa.me/5547991660018?text=${msg}`, '_blank');
                          }
                        }}
                        className="text-transform-unset fw-bold btn-rounded"
                      >
                        {plan.price === 'Grátis' ? 'Começar grátis' : 'Assinar agora'}
                      </Button>
                    </CardActions>
                  </Card>
                </Grid>
              ))}
            </Grid>
          </Container>
        </TabPanel>

        <Box component="footer" className="landing-footer">
          <Container maxWidth="lg">
            <img src={logo} alt="Petlive" className="logo-footer" />
            <Typography variant="body2" className="footer-tagline">
              A plataforma de gestão feita para quem ama pets.
            </Typography>
            <Divider className="footer-divider" />
            <Typography variant="caption" className="footer-copyright">
              © {new Date().getFullYear()} Petlive. Todos os direitos reservados.
            </Typography>
          </Container>
        </Box>

      </Box>
    </Box >
  );
};
